module.exports = __webpack_public_path__ + "static/media/salao_atico_2.5154e80f.jpg";